import { keyframes } from '@emotion/react'
import { styled, Typography } from '@mui/material'

import { theme } from 'styles/theme'

const MOBILE_BREAKPOINT = '@media (max-width: 640px)'

const gradientShift = keyframes`
  0%   { background-position: 0% 50%; }
  50%  { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`

export const Banner = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '16px',
  padding: '16px 20px',
  borderRadius: '16px',
  background: 'rgba(220, 220, 220, 0.07)',
  backdropFilter: 'blur(15px)',
  WebkitBackdropFilter: 'blur(15px)',
  border: '1px solid rgba(255, 255, 255, 0.4)',
  boxShadow: '0px 1.27px 15.27px 0px rgba(0, 0, 0, 0.05)',
  margin: '12px 20px 0',
  [MOBILE_BREAKPOINT]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '14px',
    margin: '12px 12px 0',
    padding: '16px'
  }
})

export const Content = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  flex: 1,
  minWidth: 0,
  [MOBILE_BREAKPOINT]: {
    alignItems: 'flex-start'
  }
})

export const IconBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  borderRadius: '12px',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  boxShadow: `0 4px 16px 0 ${theme.palette.primary.main}33`,
  flexShrink: 0
})

export const Texts = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  flex: 1,
  minWidth: 0
})

export const Title = styled(Typography)({
  fontSize: '15px',
  fontWeight: 600,
  background: `linear-gradient(135deg, ${theme.palette.neutral[200]} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.secondary.main} 100%)`,
  backgroundSize: '200% 200%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: `${gradientShift} 4s ease-in-out infinite`,
  lineHeight: 1.3,
  margin: 0
})

export const Body = styled(Typography)({
  fontSize: '12.5px',
  fontWeight: 400,
  color: theme.palette.neutral[400],
  lineHeight: 1.5,
  margin: 0
})

export const Actions = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
  [MOBILE_BREAKPOINT]: {
    width: '100%',
    justifyContent: 'flex-end'
  }
})

export const DismissButton = styled('button')({
  background: 'transparent',
  border: 'none',
  color: theme.palette.neutral[400],
  fontSize: '12px',
  fontWeight: 500,
  cursor: 'pointer',
  padding: '8px 12px',
  borderRadius: '8px',
  whiteSpace: 'nowrap',
  fontFamily: 'inherit',
  transition: 'background-color 150ms ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  }
})

// ========== Install instructions dialog (flat style) ==========

export const StepRow = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '14px',
  padding: '14px 0',
  borderBottom: `1px solid ${theme.palette.neutral[700]}`,
  '&:last-of-type': {
    borderBottom: 'none'
  }
})

export const StepNumber = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '28px',
  height: '28px',
  borderRadius: '50%',
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
  color: '#ffffff',
  fontSize: '13px',
  fontWeight: 700,
  flexShrink: 0
})

export const StepText = styled('p')({
  fontSize: '14px',
  lineHeight: 1.5,
  color: theme.palette.neutral[200],
  fontWeight: 400,
  margin: 0,
  flex: 1,
  '& strong': {
    fontWeight: 600
  }
})

export const StepIcon = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: theme.palette.neutral[300],
  marginTop: '2px'
})
